import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import isFunction from 'lodash/isFunction';
import Button from '@Components/Button';
import RouteOverviewTreePopup from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';

import './MultiStepReactionDialog.custom.scss';

function MultiStepReactionPreviewDialog({
  // from own props
  databaseId,
  rootReactionId,
  stepReactionIds,
  onClose,
  singleReaction,
  // from Redux
  isLoading,
  routeLayout,
  addProjectIsLoading,
  fetchMultiStepReactionPreview,
  submitMultiStepReactionProject,
  submitSingleStepReactionProject,
  multiStepReactionDialogClearState,
  // dialogs stuff
  selfClose,
  ...otherProps
}) {
  const history = useHistory();
  useEffect(() => {
    // Fetch data
    fetchMultiStepReactionPreview({ databaseId, rootReactionId, stepReactionIds });

    // Clean-up
    return () => {
      isFunction(onClose) && onClose();
      multiStepReactionDialogClearState();
    };
  }, []);

  const onTransferHandler = async () => {
    if (addProjectIsLoading) {
      return;
    }
    if(singleReaction) {
      await submitSingleStepReactionProject({ databaseId, reactionId: rootReactionId, history });
    } else {
      await submitMultiStepReactionProject({ databaseId, rootReactionId, stepReactionIds, history });
    }
    selfClose();
  };

  return (
    <RouteOverviewTreePopup
      {...otherProps}
      className="multi-step-reaction-dialog"
      routeName={`${singleReaction ? '' : 'Multi-step: '}Reaction ID ${rootReactionId}`}
      isLoading={isLoading}
      treeList={routeLayout}
      footerClassName="multi-step-reaction-dialog__footer"
      footer={
        <Button
          disabled={!routeLayout}
          buttonConfig={{ type: 'primary', size: 'sm', label: 'Transfer to Retrosynthesis', e2eName: 'transfer-to-synthesis' }}
          iconConfig={{ name: 'chevron-right' }}
          onClick={onTransferHandler}
        />
      }
      selfClose={selfClose}
    />
  );
}

MultiStepReactionPreviewDialog.defaultProps = {
  onClose: () => {},
  fetchMultiStepReactionPreview: () => {},
  submitMultiStepReactionProject: () => {},
  submitSingleStepReactionProject: () => {},
  multiStepReactionDialogClearState: () => {},
  singleReaction: false,
}

MultiStepReactionPreviewDialog.propTypes = {
  databaseId: PropTypes.string,
  rootReactionId: PropTypes.string,
  stepReactionIds: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
  isLoading: PropTypes.bool,
  singleReaction: PropTypes.bool,
  routeLayout: PropTypes.array,
  addProjectIsLoading: PropTypes.bool,
  fetchMultiStepReactionPreview: PropTypes.func,
  submitMultiStepReactionProject: PropTypes.func,
  submitSingleStepReactionProject: PropTypes.func,
  multiStepReactionDialogClearState: PropTypes.func,
};

export default MultiStepReactionPreviewDialog;
